import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IMyMonitoringUserModel } from '@apps-common/types/portal/users'

const updateClientAccountAssociation = async (model: IMyMonitoringUserModel): Promise<boolean> =>
  axios.post(`/clientaccount/UpdateAccountAssociation`, model).then((res) => res?.data?.result)

type Props = {
  model: IMyMonitoringUserModel
}

export const useUpdateClientAccountAssociation = (
  notify?: boolean,
  onSuccess?: (data: boolean) => void,
  successMsg?: string,
  errorMsg?: string
) =>
  useMutation({
    mutationKey: ['updateClientAccountAssociation'],
    mutationFn: ({ model }: Props) => updateClientAccountAssociation(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess(successMsg || 'User added.')
      }
    },
    onError: () => {
      if (notify) {
        toastError(errorMsg || 'Failed to add user.')
      }
    },
    throwOnError: false
  })
